import React, { useContext } from 'react';

import { InputFiles } from '../../../common';
import { NavContext } from "../../../contexts";
import { ComuniContext } from '../ComuniContext';

import CloseIcon from '@mui/icons-material/Close';

import {Button, Grid, Dialog, DialogContent, DialogTitle, IconButton, Typography} from '@mui/material';
import { Formik } from 'formik';

export const ImportDialog = ({
    title,
    open,
    setOpen,
    disabled,
    onActionClick,
    ...props }) => {

    const {
        getRouteTo,
        navigateTo,
    } = useContext(NavContext);

    const {
        state,
    } = useContext(ComuniContext);

    const {
    } = state;

    const uploadClickHandler = async (data) => {
        if (onActionClick)
            onActionClick("Upload", data);
    }

    const autoUploadClickHandler = async () => {
        if(onActionClick)
            onActionClick("AutoUpload");
    }

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Dialog open={open} onClose={handleClose}>
                <IconButton
                    aria-label="close"
                    size="small"
                    sx={{
                        position: "absolute",
                        top: 4,
                        right: 4,
                    }}
                    onClick={() => setOpen(false)}>
                    <CloseIcon />
                </IconButton>
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
                    {title}
                </DialogTitle>
                <DialogContent>
                    <Formik
                        onSubmit={null}>
                        {({
                            values,
                            handleSubmit,
                            setFieldValue,
                            errors,
                            touched,
                            setTouched,
                        }) => {
                            return <form onSubmit={handleSubmit}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Button variant="contained" disableElevation fullWidth onClick={autoUploadClickHandler}>
                                            Importazione automatica
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} paddingY={2}>
                                        <Typography align="center">
                                            oppure
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InputFiles
                                            disabled={disabled}
                                            singleFile
                                            title="File"
                                            customUpload
                                            onFileSelect={uploadClickHandler}
                                        />
                                    </Grid>
                                </Grid>
                            </form>
                        }}
                    </Formik>
                </DialogContent>
            </Dialog>
        </>
    );
}